import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Compass } from "lucide-react";
import { motion, AnimatePresence } from "framer-motion";

// Mobile-only sticky bottom CTA. Appears once the user scrolls past the hero,
// giving a constant conversion trigger. Hidden on md+ (desktop keeps the hero CTA).
export function MobileStickyCTA() {
  const { t } = useTranslation();
  const [show, setShow] = useState(false);

  useEffect(() => {
    const hero = document.getElementById("hero-anchor");
    if (!hero) return;
    const io = new IntersectionObserver(
      ([entry]) => setShow(!entry.isIntersecting),
      { threshold: 0 }
    );
    io.observe(hero);
    return () => io.disconnect();
  }, []);

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          initial={{ y: 90 }}
          animate={{ y: 0 }}
          exit={{ y: 90 }}
          transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }}
          className="fixed inset-x-0 bottom-0 z-40 flex md:hidden px-3 pt-3 pb-[max(0.75rem,env(safe-area-inset-bottom))] bg-[#0b0e14]/90 backdrop-blur-xl border-t border-primary/20"
          data-testid="mobile-sticky-cta"
        >
          <Link
            to="/entrer"
            data-testid="mobile-sticky-cta-btn"
            className="btn-frost-orange w-full flex items-center justify-center gap-3 py-3 rounded-full font-semibold text-base"
          >
            <span>{t("landing.cta")}</span>
            <Compass size={18} strokeWidth={2.2} />
          </Link>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
